<div class="carousel">
  <owl-carousel-o [options]="customCarouselOptions"
                  #carousel
                  (change)="onChange()"
                  (translated)="getTranslatedData($event)">
    <ng-container *ngFor="let item of externalLinks; trackBy: trackById; let i=index;">

      <ng-template carouselSlide
                   [id]="item.id"
                   [width]="item.width">
        <a [href]="item.link"
           (click)="handleExternalLinkTracking(item.trackingLabel)"
           [mmTestTarget]="'desktopBucketItem-' + i"
        >
          <div class="carousel__item"
               [class.active]="item.active">
            <img
              loading="lazy"
              [src]="item.icon"
              alt="icon" />
            <span>{{ item.title | translate }}</span>
          </div>
        </a>
      </ng-template>

    </ng-container>
  </owl-carousel-o>


  <span *ngIf="showLeftArrow"
        class="carousel__left-arrow"
        (click)="carousel.prev()">
    <app-svg-chevron-left class='carousel__arrow-icon'></app-svg-chevron-left>
  </span>
  <span *ngIf="showRightArrow"
        class="carousel__right-arrow"
        (click)="carousel.next()">
    <app-svg-chevron-right class='carousel__arrow-icon'></app-svg-chevron-right>
  </span>
</div>

<ul class="carousel mobile">
  <a *ngFor="let item of externalLinks; trackBy: trackById; let i=index;"
     [href]="item.link"
     (click)="handleExternalLinkTracking(item.trackingLabel)"
     [mmTestTarget]="'mobileBucketItem-' + i"
  >
    <li class="carousel__item"
        [ngClass]="{ active: item.active }">
      <img
          loading="lazy"
          [src]="item.icon"
          class="icon"
          alt="icon"
      />
      <span class="title">{{ item.title | translate }}</span>
    </li>
  </a>
</ul>
